export const EVENT_STATUS_OPTIONS = [
  { value: "confirmed", label: "Confirmed", color: "amber" },
  { value: "not_confirmed", label: "Not confirmed", color: "sky" },
  { value: "cancelled", label: "Cancelled", color: "ink" },
];

export function eventStatusLabel(status) {
  return EVENT_STATUS_OPTIONS.find((o) => o.value === status)?.label || "Confirmed";
}

export function eventStatusColor(status) {
  return EVENT_STATUS_OPTIONS.find((o) => o.value === status)?.color || "amber";
}

export function toDatetimeLocalValue(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromDatetimeLocalValue(value) {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}
